import { render } from "./NewsFeedView.vue?vue&type=template&id=439b9577"
import script from "./NewsFeedView.vue?vue&type=script&lang=js"
export * from "./NewsFeedView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__